import { apiWrapper } from "apis/CommonApi";
import Pagenation from "components/Pagenation";
import { forwardRef, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as fireonApi from "../../apis/FireOnApi";
import { getDate, getDateTime, getTime } from "utils/date";
import { FireAlarmHistoryResultChoices, getFireAlarmHistoryResultName } from "utils/common";
import { API_HOST } from "Constants";
import { useReactToPrint } from "react-to-print";
import { useAppContext } from "utils/store";
import FireOnToolbar from "./FireOnToolbar";

export default function FireAlarmHistoryComponent(props) {
    const location = useLocation();
    const { buildingName, serialNumber, dei } = location.state;

    return (
        <>
            <div className="viewBoard fireOnBoard fireItemListBoard fahBoard">
                <TopBoard currentDateTime={props.currentDateTime} />
                <MidBoard />
                <FireOnToolbar item="화재경보 발생이력" buildingName={buildingName} serialNumber={serialNumber} dei={dei} />
            </div>
        </>
    );
}

const TopBoard = ({ currentDateTime }) => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { store: { userName } } = useAppContext();
    const location = useLocation();

    const handleGoBack = () => {
        navigate(`/fire-on/alarm-monitor/${id}`, location.state);
    }

    return (
        <>
            <div className="top_board mb">
                <div className="wrap_logo">
                    {/* <img src="" alt="" className="img_logo" /> */}
                </div>
                <div className="header_dept">
                    <p className="user">COWORKER</p>
                    <div className="wrap_contr">
                        <a className="set_contr" href="#">
                            <img src="/images/my_btn_mb_w.png" alt="" />
                        </a>
                    </div>
                </div>
            </div>

            <div className="top_board navi_board">
                <div className="wrap_navi">
                    <button className="arrow_navi" onClick={handleGoBack}>
                        <i className="x-icon arrow_icon"></i>
                    </button>
                    <p className="title_navi">화재경보 발생이력</p>
                </div>
                <div className="wrap_right pc">
                    <div className="wrap_userBox">
                        <div className="wrap_userInfo pc">
                            <p className="current_date">{currentDateTime}</p>
                        </div>
                        <p className="user_id">{userName}</p>
                    </div>
                </div>
            </div>
        </>
    );
};

const MidBoard = () => {
    const { id } = useParams();
    const location = useLocation();
    const { buildingName } = location.state;
    const itemsPerPage = 100;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [historyId, setHistoryId] = useState(null);
    const [dataSource, setDataSource] = useState([]);
    const [previous, setPrevious] = useState(null);
    const [next, setNext] = useState(null);
    const [page, setPage] = useState(1);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [checkedIds, setCheckedIds] = useState([]);
    const printRef = useRef();

    useEffect(() => {
        getData(1);
    }, []);

    //page: 1베이스
    const getData = (page, url = null) => {
        apiWrapper(async () => {
            let result;
            if (url !== null) {
                result = await fireonApi.getFireAlarmHistoryListByUrl(url);
            } else {
                result = await fireonApi.getFireAlarmHistoryList(
                    id,
                    startDate,
                    endDate,
                    page,
                    itemsPerPage
                );
            }

            const { status, data } = result;
            if (status === true) {
                setDataSource(data);

                setPrevious(data.previous);
                setNext(data.next);
                setPage(page);
            } else {
                alert(`${data}`);
            }
        });
    };

    const handleCheckAll = (e) => {
        if (e.target.checked) {
            setCheckedIds(dataSource.results.map((a) => a.id));
        } else {
            setCheckedIds([]);
        }
    }

    const handleChangeChecked = (e, id) => {
        if (e.target.checked) {
            setCheckedIds([...checkedIds, id]);
        } else {
            setCheckedIds(checkedIds.filter((a) => a !== id));
        }
    }

    const handlePageArrowClick = (page, isNext) => {
        let url = null;
        if (isNext === false) {
            url = previous;
        } else {
            url = next;
        }

        getData(page, url);
    }

    const handleSearch = () => {
        getData(page);
    }

    const handleExportExcel = () => {
        apiWrapper(async () => {
            const { status, data } = await fireonApi.downloadExcelFireAlarmHistoryList(id, startDate, endDate);
            if (status === false) {
                alert(`엑셀 저장에 실패하였습니다.\n${data}`);
            }
        });
    }

    const openModal = (historyId) => {
        setHistoryId(historyId);

        setIsModalOpen(true);
        setTimeout(() => {
            const modalContent = document.querySelector(".modal_content");
            if (modalContent) {
                modalContent.style.transform = "translateX(0)";
            }
        }, 10);
    };

    const closeModal = () => {
        const modalContent = document.querySelector(".modal_content");
        if (modalContent) {
            modalContent.style.transform = "translateX(100%)";
        }
        setTimeout(() => {
            setIsModalOpen(false);
        }, 500);
    };

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
        documentTitle: "화재경보 발생이력",
    });

    const handleDelete = () => {
        if (window.confirm("삭제하시겠습니까?")) {
            apiWrapper(async () => {
                const { status, data } = await fireonApi.bulkDeleteFireAlarmHistory(checkedIds);
                alert(`${data}`)

                //삭제 성공 시 새로고침
                if (status === true) {
                    setCheckedIds([]);
                    getData();
                }
            });
        }
    }

    return (
        <>
            <div className="mid_board mid_col_board">
                <div className="wrap_mid_le">
                    <p className="title_mid">{buildingName}</p>
                </div>
                <div className="wrap_right pc">
                    <div className="wrap_item_contr mid_input_container">
                        <div className="wrap_detail_item">
                            <div className="detail_box detail_date_box">
                                <div className={`date-input-wrap ${startDate ? "selected" : ""}`}>
                                    <p class="date_all_title">검색기간</p>
                                    <input type="date" class="form-input" id="start_date" onChange={(e) => setStartDate(e.target.value)} />
                                    <p class="date-title">{startDate}</p>
                                </div>
                                <span className="divi-col">-</span>
                                <div className={`date-input-wrap ${endDate ? "selected" : ""}`}>
                                    <input type="date" class="form-input" id="end_date" onChange={(e) => setEndDate(e.target.value)} />
                                    <p class="date-title right-title">{endDate}</p>
                                </div>
                            </div>
                        </div>
                        <div className="wrap_item_contr">
                            <button className="btn_contr" onClick={handleSearch}>
                                <i className="x-icon"></i>
                            </button>
                            <button className="btn_contr" onClick={handleExportExcel}>엑셀</button>
                        </div>
                    </div>
                </div>
            </div >
            <TableBoard printRef={printRef} dataSource={dataSource} openModal={openModal} checkedIds={checkedIds} handleCheckAll={handleCheckAll} handleChangeChecked={handleChangeChecked} />

            <div class="wrap_controll">
                <div id="pagination">
                    <Pagenation
                        totalItemsCount={dataSource.count}
                        itemsPerPage={itemsPerPage}
                        selectedPage={page}
                        setPage={(value) => setPage(value)}
                        handlePageArrowClick={handlePageArrowClick}
                    />
                </div>
            </div>

            {checkedIds.length > 0 && (
                <div class="toolbar" style={{ display: 'block' }}>
                    <div class="wrap_inner">
                        <button class="btn_tb " onClick={handlePrint}>출력</button>
                        <button class="btn_tb " onClick={handleDelete}>삭제</button>
                    </div>
                </div>
            )}

            {isModalOpen && <Modal historyId={historyId} closeModal={closeModal} getData={() => getData(page)} />}
        </>
    );
};

const TableBoard = forwardRef(({ printRef, dataSource, openModal, checkedIds, handleCheckAll, handleChangeChecked }) => {
    return (
        <>
            <div ref={printRef} className="table_board">
                <div className="wrap_right mb">
                    <div className="wrap_item_contr">
                        <div className="building_info">
                            <div className="item_info">
                                <p className="txt_info title_info">일련번호</p>
                                <p className="txt_info code_info">123456789</p>
                            </div>
                            <div className="item_info">
                                <p className="txt_info title_info">DEI 코드</p>
                                <p className="txt_info code_info">sj521hfg58j86215</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="wrap_table scroll_table">
                    <div className="containerTable fahTable">
                        <ul className="head_table">
                            <li>
                                <input className="all_chk" type="checkbox" onChange={handleCheckAll} />
                            </li>
                            <li><p>관리ID</p></li>
                            <li><p>발생일시</p></li>
                            <li><p>발생내역</p></li>
                            <li><p>확인일시</p></li>
                            <li><p>확인자</p></li>
                            <li><p>연락처</p></li>
                            <li><p>확인/조치사항</p></li>
                            <li><p>결과구분</p></li>
                            <li><p>첨부사진</p></li>
                        </ul>

                        <div className="body_table">
                            <div className="inner_table_wrap">
                                {dataSource.results &&
                                    dataSource.results.map((item, index) => (
                                        <div className={`wrap_table_item item_state ${checkedIds.includes(item.id) ? '' : 'print-hidden'}`} key={index}>
                                            <div className="inner_table_item table_item_01">
                                                <input className="cont_table_chekbox" type="checkbox" checked={checkedIds.includes(item.id)} onClick={(e) => handleChangeChecked(e, item.id)} />
                                            </div>
                                            <div className="inner_table_item table_item_02 modal-td" onClick={() => openModal(item.id)}>
                                                <p className="cont_table_item">{item.id}</p>
                                            </div>
                                            <div className="inner_table_item table_item_03">
                                                <p className="cont_table_item">{getDateTime(new Date(item.eventTime))}</p>
                                            </div>
                                            <div className="inner_table_item table_item_04">
                                                <p className="cont_table_item">{item.description}</p>
                                            </div>
                                            <div className="inner_table_item table_item_05">
                                                <p className="cont_table_item">{item.confirmedAt ? getDateTime(new Date(item.confirmedAt)) : null}</p>
                                            </div>
                                            <div className="inner_table_item table_item_06">
                                                <p className="cont_table_item">{item.confirmer}</p>
                                            </div>
                                            <div className="inner_table_item table_item_07">
                                                <p className="cont_table_item">{item.contact}</p>
                                            </div>
                                            <div className="inner_table_item table_item_08">
                                                <p className="cont_table_item">{item.action}</p>
                                            </div>
                                            <div className="inner_table_item table_item_09">
                                                <p className="cont_table_item">{getFireAlarmHistoryResultName(item.resultType)}</p>
                                            </div>
                                            <div className="inner_table_item table_item_10">
                                                <p className="cont_table_item">{item.images.length > 0 ? "유" : "무"}</p>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

const Modal = ({ historyId, closeModal, getData }) => {
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        setFormDataProperty("id", "");
        setFormDataProperty("eventTime", "");
        setFormDataProperty("description", "");
        setFormDataProperty("confirmedDate", "");
        setFormDataProperty("confirmedTime", "");
        setFormDataProperty("confirmer", "");
        setFormDataProperty("contact", "");
        setFormDataProperty("action", "");
        setFormDataProperty("resultType", "1");
        setFormDataProperty("images", []);

        apiWrapper(async () => {
            const { status, data } = await fireonApi.getFireAlarmHistory(historyId);
            if (status === true) {
                setFormDataProperty("id", data.id);
                setFormDataProperty("eventTime", data.eventTime);
                setFormDataProperty("description", data.description);
                setFormDataProperty("confirmedDate", data.confirmedAt ? getDate(new Date(data.confirmedAt)) : "");
                setFormDataProperty("confirmedTime", data.confirmedAt ? getTime(new Date(data.confirmedAt)) : "");
                setFormDataProperty("confirmer", data.confirmer);
                setFormDataProperty("contact", data.contact);
                setFormDataProperty("action", data.action);
                setFormDataProperty("resultType", data.resultType === "" ? "1" : data.resultType);

                //이미지 URL -> Blob 변환
                try {
                    for (let i = 0; i < data.images.length; i++) {
                        let image = data.images[i];
                        const response = await fetch(API_HOST + image.image);
                        if (!response.ok) {
                            throw new Error(`${response.status}`);
                        }

                        const blob = await response.blob();
                        const file = new File([blob], image.imageFilename, { type: blob.type });
                        setFormDataProperty("images", [...formData.images, file]);
                    }
                } catch (error) {
                    console.error("이미지 URL을 Blob 객체로 변환 실패 : ", error)
                }
            } else {
                alert(`${data}`);
            }
        });
    }, []);

    const setFormDataProperty = (name, value) => {
        setFormData((currentFormData) => {
            const nextFormData = {
                ...currentFormData,
                [name]: value,
            };
            //console.log(nextFormData);
            return nextFormData;
        });
    };

    const onChange = (e) => {
        if (e.target.type === 'file') {
            const newFiles = e.target.files;
            if (newFiles.length > 0) {
                setFormDataProperty("images", [...formData.images, ...newFiles]);
            }
        } else {
            let name = e.target.name;
            let value = e.target.value;
            setFormDataProperty(name, value);
        }
    };

    const handleDeleteFile = (e) => {
        setFormDataProperty("images", formData.images.filter(item => item !== e));
    }

    const handleSave = (e) => {
        e.preventDefault();

        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
        } else if (checkValid() === false) {
            e.stopPropagation();
        } else {
            apiWrapper(async () => {
                const requestBody = new FormData();
                if (formData.images.length > 0) {
                    formData.images.map((file) => {
                        requestBody.append("images", file);
                    });
                }
                requestBody.append("payload",
                    JSON.stringify({
                        confirmedAt: new Date(`${formData.confirmedDate} ${formData.confirmedTime}`),
                        confirmer: formData.confirmer,
                        contact: formData.contact,
                        action: formData.action,
                        resultType: formData.resultType,
                    }));

                const { status, data } = await fireonApi.updateFireAlarmHistory(historyId, requestBody);
                alert(`${data}`);

                if (status === true) {
                    closeModal();

                    //성공 시 새로고침
                    getData();
                }
            });
        }
    }

    const checkValid = () => {
        return true;
    }

    return (
        <div id="modal" class="modal rightModal noticeRightModal open"
            onClick={(e) => {
                if (e.target === e.currentTarget)
                    closeModal();
            }}>
            <form class="modal_content" onSubmit={handleSave}>
                <button type="button" class="close_modal" onClick={closeModal}>
                    <i class="x-icon close_icon"></i>
                </button>
                <h2>화재경보 발생이력 보고서</h2>
                {formData && (
                    <div class="wrap_detail_cont veiw_radio_cont">
                        <div class="wrap_detail_item">
                            <p class="title_detail">관리 ID</p>
                            <div class="detail_box">
                                {formData.id}
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">발생일시</p>
                            <div class="detail_box">
                                {getDateTime(new Date(formData.eventTime))}
                            </div>
                        </div>
                        <div class="wrap_detail_item">
                            <p class="title_detail">발생내역</p>
                            <div class="detail_box">
                                {formData.description}
                            </div>
                        </div>
                        <div class="wrap_detail_item default_type_item">
                            <p class="title_detail">확인일시</p>
                            <div class="detail_box detail_date_box">
                                <div className={`date-input-wrap ${formData.confirmedDate ? "selected" : ""}`}>
                                    <p class="date-title" style={{ display: formData.confirmedDate ? "none" : "block" }}>{formData.confirmedDate || '년-월-일'}</p>
                                    <input type="date" class="form-input" id="start_date" name="confirmedDate" value={formData.confirmedDate} onChange={onChange} />
                                </div>
                                <div
                                    className={`date-input-wrap ${formData.confirmedTime ? "selected" : ""}`} >
                                    <p className="date-title" style={{ display: formData.confirmedTime ? "none" : "block" }}>{formData.confirmedTime || '시간'}</p>
                                    <input type="time" className={`form-input ${formData.confirmedTime ? "selected" : ""}`} id="time" name="confirmedTime" value={formData.confirmedTime} onChange={onChange} />
                                </div>
                            </div>
                        </div>
                        <div class="wrap_detail_item default_type_item">
                            <p class="title_detail">확인자</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="확인자명을 작성해주세요." name="confirmer" value={formData.confirmer} onChange={onChange} required />
                            </div>
                        </div>
                        <div class="wrap_detail_item default_type_item">
                            <p class="title_detail">연락처</p>
                            <div class="detail_box">
                                <input class="default_input" type="text" placeholder="연락처를 입력해주세요." name="contact" value={formData.contact} onChange={onChange} required />
                            </div>
                        </div>

                        <div class="wrap_detail_item default_type_item">
                            <p class="title_detail">확인조치사항</p>
                            <div class="detail_box">
                                <textarea class="detail_textarea" placeholder="확인조치사항을 작성해주세요." name="action" value={formData.action} onChange={onChange} required>
                                </textarea>
                            </div>
                        </div>

                        <div class="wrap_detail_item title-w">
                            <p class="title_detail">결과구분</p>
                            <div class="detail_box detail-duble-box ">
                                <div class="wrap_inner wrap_raido_inner">
                                    {Object.values(FireAlarmHistoryResultChoices).map((item, index) => (
                                        <label for={`radio_${index}`} class="radio-item">
                                            <input type="radio" id={`radio_${index}`} class="form-radio" name="resultType" value={item} checked={formData.resultType === item} onChange={onChange} />
                                            <span class="radio-icon">
                                                <i class="xi-check"></i>
                                            </span>
                                            <p class="radio-title">{getFireAlarmHistoryResultName(item)}</p>
                                        </label>
                                    )
                                    )}
                                </div>
                            </div>
                        </div>
                        <div class="file-wrapper title-w">
                            <p class="title_detail">첨부파일</p>
                            <div class="file-input">
                                <label for="file-upload" class="file-upload-btn">+</label>
                                <input type="file" id="file-upload" class="file-upload-input" name="images" multiple onChange={onChange} />
                            </div>
                            <div class="file-name-container">
                                {formData.images.map((item, index) => (
                                    <div class="file-item">
                                        <span id="file-name">{item.name}</span>
                                        <button type="button" id="remove-btn" class="remove-btn" onClick={() => handleDeleteFile(item)}>X</button>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <button type="submit" class="btn_dark">저장</button>
                    </div>
                )}
            </form>
        </div >
    );
}